<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>


<div class="central-loader" *ngIf="configService.loadingMall || !configService.mall">
  <div class="absolute-center">
    <ion-spinner name="crescent" *ngIf="configService.loadingMall"></ion-spinner>

    <div *ngIf="!configService.loadingMall && !configService.mall">
      <!--TODO Add a nice picture here-->
      <h1 class="ion-text-center">
        Nos encontramos realizando cambios, vuelve en unos minutos.
      </h1>
    </div>
  </div>
</div>

<div class="powered-by-div">
  Powered by <a href="https://www.inkremental.co" target="_blank">Inkremental</a>
</div>